var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-divider el-divider--horizontal",style:('background-color:' + _vm.color)},[_c('div',{class:'el-divider__text is-' + _vm.contentPosition},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }